import React from 'react';

import { Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ReactHookFormInput } from 'common/components/form/bootstrap';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import validate from '../validate';

const ForgotPasswordForm = ({
    errors,
    initialValues,
    isLoadingSession,
    onSubmit,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ReactHookFormInput
                control={control}
                name="email"
                placeholder={t('Email')}
                type="email"
            />

            <ShowErrors errors={errors} />

            <Button disabled={isLoadingSession} fullWidth type="submit">
                {isLoadingSession
                    ? t('Loading').concat('...')
                    : t('Send email')}
            </Button>
        </form>
    );
};

ForgotPasswordForm.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isLoadingSession: PropTypes.bool,
    onSubmit: PropTypes.func,
};

export default ForgotPasswordForm;
